import { render, staticRenderFns } from "./freightRules.vue?vue&type=template&id=777974f6&scoped=true"
import script from "./freightRules.vue?vue&type=script&lang=js"
export * from "./freightRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777974f6",
  null
  
)

export default component.exports